module.exports = __webpack_public_path__ + "img/member-h5-clean.94b8653a.png";